/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAsteriskAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 6.196V3h2v3.196l3.024-1.638.952 1.759L14.1 7.875l2.876 1.558-.952 1.759L13 9.554v3.196h-2V9.554l-3.024 1.638-.952-1.759L9.9 7.875 7.024 6.317l.952-1.759L11 6.196z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAsteriskAlt as AsteriskAlt };
